<template>
    <div class="service-modal show" v-if="isVisible">
        <div class="modal-mbway-container">
            <div class="modal-mbway">
                <div class="row">
                    <div class="mbway-content">
                        <img :src="errorIco" alt="mb way">
                    </div>
                    <h3 class="my-3 text-center text-orange">Existiu um problema com o teu pagamento</h3>
                    <p class="sub-title">{{ message }}</p>

                    <div class="text-center col-md-12">
                        <button @click="cancel()" class="btn-text-only">
                            Cancelar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ic_error from '../../svg/ic_error.svg';

export default {
    props: {
        isModalOpen: {
            type: String,
            required: false
        },
        propMessage: {
            type: String,
            required: false
        },
    },
    mounted() {
        if (this.isModalOpen === '1') {
            this.isVisible = true;
        }
        if (this.propMessage) {
            this.message = this.propMessage;
        }
    },
    data() {
        return {
            isVisible: false,
            errorIco: ic_error,
            message: 'Por favor, confere as tuas informações de pagamento ou tenta de novo.'
        }
    },
    created() {
        this.$root.$on('display-modal-error-payment', (code) => {
            if (code != null && code != undefined) {
                this.message = code;
            }

            this.isVisible = true;
            document.querySelector('html').classList.add('no-scroll');
            document.querySelector('body').classList.add('no-scroll');
        });

    },

    methods: {
        cancel() {
            this.isVisible = false;
            this.message = 'Por favor, confere as tuas informações de pagamento ou tenta de novo.';

            document.querySelector('html').classList.remove('no-scroll');
            document.querySelector('body').classList.remove('no-scroll');
        }
    }
}

</script>

<style>

</style>
